/**
 *
 */
const setupMainMenu = () =>
{
	setupMobileDropdownMenu();
	setupDesktopMenu();
};


/**
 *
 */
const setupDesktopMenu = () =>
{
	const allSubMenus        = document.querySelectorAll( '#main-menu-desktop .sub-menu' );
	const firstLevelSubMenus = document.querySelectorAll( '#main-menu-desktop > li > .sub-menu' );
	const deepNestedMenus    = document.querySelectorAll( '#main-menu-desktop > li > .sub-menu > li .sub-menu' );

	// make submenus after the 3rd main item open left

	firstLevelSubMenus.forEach( ( subMenu, key ) =>
	{
		const subSubMenus = subMenu.querySelectorAll( '.sub-menu' );

		if (key > 2) {
			subSubMenus.forEach( subSubMenu => subSubMenu.classList.add( 'opens-left' ) );
		}
	} );

	// make any submenus nested deeper than 2 open to the left

	deepNestedMenus.forEach( subMenu =>
	{
		const subSubMenus = subMenu.querySelectorAll( '.sub-menu' );

		subSubMenus.forEach( subSubMenu => subSubMenu.classList.add( 'opens-left' ) );
	} );

	// prevent flash of submenus while stylesheet is being loaded

	setTimeout( () =>
	{
		allSubMenus.forEach( subMenu => subMenu.style.removeProperty( 'visibility' ) );
	}, 500 );
};


/**
 *
 */
const setupMobileDropdownMenu = () =>
{
	const dropdownContent = document.querySelector( '#main-nav-content' );
	const dropdownLis     = document.querySelectorAll( '.custom-dropdown-menu > .nav-item.dropdown' );
	const allDropdownLis  = document.querySelectorAll( '.custom-dropdown-menu .nav-item.dropdown' );
	const toggler         = document.querySelector( '#site-header .navbar-toggler' );

	/**
	 *
	 * @param {HTMLElement} el
	 * @return {boolean}
	 */
	const elementIsVisible = el =>
	{
		return el.getBoundingClientRect().height > 0
	};

	/**
	 *
	 * @param {HTMLLIElement} menuListItem
	 */
	const recordHeight = menuListItem =>
	{
		const menu           = menuListItem.querySelector( '.dropdown-menu' );
		const childListItems = menuListItem.querySelectorAll( '.nav-item.dropdown' );

		menu.style.display = 'block';

		const height = menu.offsetHeight;

		menu.setAttribute( 'data-height', height );

		childListItems.forEach( item =>
		{
			if (item.closest( '.dropdown-menu' ) === menu) {
				recordHeight( item );
			}
		} );

		menu.style.removeProperty( 'display' );
	};

	/**
	 *
	 * @param {HTMLUListElement} menu
	 * @param {number} menuHeight
	 */
	const adjustParentMenuHeight = ( menu, menuHeight ) =>
	{
		const parentMenu = menu.parentElement.closest( '.dropdown-menu.open' );

		if (parentMenu) {

			const parentActualHeight = parseInt( parentMenu.style.height, 10 );
			const parentNewHeight    = parentActualHeight + menuHeight;

			parentMenu.style.height = parentNewHeight + 'px';

			adjustParentMenuHeight( parentMenu, menuHeight );
		}
	};

	/**
	 *
	 * @param {HTMLUListElement} menu
	 * @param {HTMLElement} toggle
	 */
	const toggleMenu = ( menu, toggle ) =>
	{
		const menuHeight = parseInt( menu.dataset.height, 10 );

		if (menu.classList.contains( 'open' )) {

			menu.style.height = '0';
			toggle.classList.remove( 'open' );

			adjustParentMenuHeight( menu, -menuHeight );

			setTimeout( () =>
			{
				menu.classList.remove( 'open' );
			}, 500 );

		} else {

			menu.classList.add( 'open' );
			toggle.classList.add( 'open' );

			setTimeout( () =>
			{
				menu.style.height = menuHeight + 'px';

				adjustParentMenuHeight( menu, menuHeight );
			}, 10 );
		}
	};

	/**
	 *
	 */
	const doSetup = () =>
	{
		dropdownContent.style.opacity = '0';
		dropdownContent.style.display = 'block';
		dropdownLis.forEach( li => recordHeight( li ) );
		dropdownContent.style.removeProperty( 'display' );
		dropdownContent.style.removeProperty( 'opacity' );

		allDropdownLis.forEach( li =>
		{
			const toggle = li.querySelector( '.dropdown-toggle' );
			const menu   = li.querySelector( '.dropdown-menu' );

			toggle.addEventListener( 'click', e =>
			{
				e.preventDefault();
				toggleMenu( menu, toggle );
			} );
		} );
	};

	/**
	 *
	 */
	const doSetupWhenTogglerAvailable = () =>
	{
		if (elementIsVisible( toggler )) {
			doSetup();
			window.removeEventListener( 'resize', doSetupWhenTogglerAvailable );
		}
	};


	if (elementIsVisible( toggler )) {
		doSetup();
	} else {
		window.addEventListener( 'resize', doSetupWhenTogglerAvailable );
	}
};


/**
 *
 */
export default setupMainMenu;